import React from 'react';
import {useNavigate, useParams} from 'react-router';
import {CheckOutlined} from '@ant-design/icons';
import {useQuery} from '@apollo/client';
import {Button, Spin} from 'antd';
import cn from 'classnames';

import {ENUM_ORDER_ORDER_STATUS} from '../../__generated__/global-types';
import {INDEX} from '../../config/routes';
import {order, orderVariables} from '../../shared/graphql/__generated__/order';
import {QUERY_ORDER} from '../../shared/graphql/order';

import {Payment} from './Payment';

import cls from './Order.module.scss';

export const Order = () => {
    const {id} = useParams<{id: string}>();
    const navigate = useNavigate();
    
    const {data, loading, error} = useQuery<order, orderVariables>(QUERY_ORDER, {
        variables: {
            documentId: id!
        },
        skip: !id
    });

    if (loading) {
        return (
            <div className={cn(['half', cls.page])}>
                <Spin size="large" />
            </div>
        );
    }

    if (error || !data?.order) {
        return (
            <div className={cn(['half', cls.page])}>
                <h1>Ошибка заказа</h1>
                <div style={{marginBottom: '24px'}}>
                    Заказ с указанным идентификатором не найден или произошла ошибка при загрузке данных.
                </div>
                <Button type={'primary'} onClick={() => navigate(INDEX)}>Хорошо</Button>
            </div>
        );
    }

    const orderData = data.order;

    const renderOrderInfo = () => (
        <>
            <div className={cls.block}>
                <h2>Информация о заказе</h2>
                <div className={cls.info}>
                    <div>Номер заказа:</div><div className={'bold'}>{orderData.id}</div>
                    <div>Имя:</div><div className={'bold'}>{orderData.first_name} {orderData.last_name}</div>
                    <div>Email:</div><div className={'bold'}>{orderData.email}</div>
                    <div>Телефон:</div><div className={'bold'}>{orderData.phone}</div>
                </div>
            </div>

            <div className={cls.block}>
                <h2>Стоимость</h2>
                <div className={cls.info}>
                    <div>Сумма:</div><div className={'bold'}>{orderData.cost_sum} ₽</div>
                    {orderData.cost_discount !== 0 && (
                        <><div>Скидка:</div><div className={'bold'}>{orderData.cost_discount} ₽</div></>
                    )}
                    <div>Доставка:</div><div className={'bold'}>{orderData.cost_delivery !== null ? `${orderData.cost_delivery} ₽` : '-'}</div>
                    <div>Итого:</div><div className={cls.price}>{orderData.cost_total} ₽</div>
                </div>
            </div>
        </>
    );

    switch (orderData.order_status) {
        case ENUM_ORDER_ORDER_STATUS.CREATED_1:
            return (
                <div className={cn(['half', cls.page])}>
                    <h1><CheckOutlined/> Заказ оформлен</h1>
                    <div>
                        Спасибо за ваш заказ! Информация о заказе направлена на электронную почту. 
                        Для завершения оформления необходимо произвести оплату.
                    </div>
                    {renderOrderInfo()}
                    <div>
                        <Payment orderId={orderData.documentId} />
                    </div>
                </div>
            );

        case ENUM_ORDER_ORDER_STATUS.FUNDED_2:
            return (
                <div className={cn(['half', cls.page])}>
                    <h1><CheckOutlined/> Заказ оформлен и оплачен</h1>
                    <div style={{marginBottom: '24px'}}>
                        Спасибо за заказ! Ваш заказ успешно оплачен. Чек и информация о заказе направлена на электронную почту. 
                        При возникновении вопросов наши менеджеры свяжутся с вами.
                    </div>
                    {renderOrderInfo()}
                    <div style={{marginTop: '24px'}}>
                        <Button type={'primary'} onClick={() => navigate(INDEX)}>Хорошо</Button>
                    </div>
                </div>
            );

        case ENUM_ORDER_ORDER_STATUS.DONE_3:
            return (
                <div className={cn(['half', cls.page])}>
                    <h1><CheckOutlined/> Заказ доставлен</h1>
                    {renderOrderInfo()}
                    <div style={{marginTop: '24px'}}>
                        <Button type={'primary'} onClick={() => navigate(INDEX)}>Хорошо</Button>
                    </div>
                </div>
            );

        case ENUM_ORDER_ORDER_STATUS.CANCELLED_4:
            return (
                <div className={cn(['half', cls.page])}>
                    <h1>Заказ отменен</h1>
                    {renderOrderInfo()}
                    <div style={{marginTop: '24px'}}>
                        <Button type={'primary'} onClick={() => navigate(INDEX)}>Хорошо</Button>
                    </div>
                </div>
            );

        case ENUM_ORDER_ORDER_STATUS.ERROR_5:
        default:
            return (
                <div className={cn(['half', cls.page])}>
                    <h1>Ошибка заказа</h1>
                    <div style={{marginBottom: '24px'}}>
                        Произошла ошибка при обработке заказа. Пожалуйста, свяжитесь с нашими менеджерами для уточнения деталей.
                    </div>
                    <div style={{marginTop: '24px'}}>
                        <Button type={'primary'} onClick={() => navigate(INDEX)}>Хорошо</Button>
                    </div>
                </div>
            );
    }
};
